import H4 from "../../../shared/typography/H4";
import Button from "../../../shared/ui/Button";
import RadioButton from "../../../shared/ui/Form/RadioButton";

const WhatsAppShareForm = ({
    selectedShare,
    setSelectedShare,
    onShare,
    loading,
}) => (
    <div className="p-4 lg:p-2">
        <H4 className="mt-2">Which proposal would you like to share?</H4>
        <div className="flex items-center gap-2 my-2">
            <RadioButton
                name="whatsappShare"
                value="Purchase"
                checked={selectedShare === "Purchase"}
                onChange={() => setSelectedShare("Purchase")}
                label="Purchase"
            />
            <RadioButton
                name="whatsappShare"
                value="Lease"
                checked={selectedShare === "Lease"}
                onChange={() => setSelectedShare("Lease")}
                label="Lease"
            />
        </div>
        <Button
            className="mt-2 w-full"
            disabled={loading}
            isLoading={loading}
            onClick={() => {
                onShare();
            }}
        >
            Share on Whatsapp
        </Button>
    </div>
);

export default WhatsAppShareForm;
